import {
    AWAITING_ACTIVATION_STATUS,
    AWAITING_AGREEMENT_STATUS,
    PAYMENT_IN_PROGRESS_STATUS,
    statusFilterLabel,
} from '../utils/dashboardStatus';

export interface DashboardFilters {
    /** wire value — do not rename; see docs/plans/2026-08-01-agreement-detail-page.md */
    record_type?: 'quote' | 'plan';
    dealer_id?: string[];
    product_id?: string[];
    salesperson_id?: string;
    status?: string[];
    date_from?: string; // ISO date string
    date_to?: string; // ISO date string
}

export interface FilterOption {
    value: string;
    label: string;
}

export interface DealerOption extends FilterOption {
    code?: string;
}

export interface ProductOption extends FilterOption {
    description?: string;
}

export interface UserOption extends FilterOption {
    email?: string;
}

// Derived statuses the API reports and `status[]` matches, not the dashboard_items.status column.
// `completed` is deliberately absent: completed quotes derive to an awaiting state (design D7).
export const STATUS_OPTIONS: FilterOption[] = [
    { value: 'live', label: 'Live (quote)' },
    { value: PAYMENT_IN_PROGRESS_STATUS, label: statusFilterLabel(PAYMENT_IN_PROGRESS_STATUS) },
    { value: 'dead', label: 'Dead (quote)' },
    { value: AWAITING_AGREEMENT_STATUS, label: statusFilterLabel(AWAITING_AGREEMENT_STATUS) },
    { value: AWAITING_ACTIVATION_STATUS, label: statusFilterLabel(AWAITING_ACTIVATION_STATUS) },
    { value: 'active', label: 'Active (agreement)' },
    { value: 'pending_cancellation', label: 'Pending cancellation (agreement)' },
    { value: 'cancelled', label: 'Cancelled (agreement)' },
];

// Label only — 'plan' is the wire value read by dashboard-service's
// dashboard_items.record_type filter and must not be renamed (see
// docs/plans/2026-08-01-agreement-detail-page.md, "Rename inventory").
export const RECORD_TYPE_OPTIONS: FilterOption[] = [
    { value: 'quote', label: 'Quote' },
    { value: 'plan', label: 'Agreement' },
];
